"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4882],{

/***/ 79534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ review_form; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewForm/review-form.styles.js




const Row = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  padding-bottom: ${(0,esm.themeGet)('space.2')}px;
`;
const Tiny = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  text-decoration: underline;
  cursor: pointer;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewForm/review-form.js


function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }







function ReviewForm({
  agreedError,
  agreedLabel,
  buttonLabel,
  onSubmit,
  ratingError,
  ratingLabel,
  recommendedError,
  recommendedLabel,
  reviewCharacteristics,
  minTextSize,
  textError,
  textLabel,
  textPlaceholder,
  titleError,
  titleLabel,
  titlePlaceholder,
  focus
}) {
  const [agreed, setAgreed] = (0,react.useState)(false);
  const [recommended, setRecommended] = (0,react.useState)('');
  const [rating, setRating] = (0,react.useState)('');
  const [title, setTitle] = (0,react.useState)('');
  const [text, setText] = (0,react.useState)('');
  const [characteristics, setCharacteristics] = (0,react.useState)(reviewCharacteristics || []);
  const [errorsValidation, setErrorsValidation] = (0,react.useState)({});
  const refs = Object.assign({
    rating: (0,react.useRef)(),
    title: (0,react.useRef)(),
    text: (0,react.useRef)(),
    recommended: (0,react.useRef)()
  }, characteristics.reduce((acc, {
    id
  }) => Object.assign({}, acc, {
    [id]: (0,react.useRef)()
  }), {}), {
    agreed: (0,react.useRef)()
  });
  const updateErrors = (0,react.useCallback)((_key, _error, _focus = focus) => {
    setErrorsValidation(_ref => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, [_key].map(_toPropertyKey));

      const errors = Object.assign({}, errs, _error);
      const keys = Object.keys(errors);

      if (_focus && keys.includes(_key) && _error) {
        const {
          current
        } = refs[keys[0]];
        window.scroll({
          top: current.offsetTop - 35,
          left: 0,
          behavior: 'smooth'
        });
      }

      return errors;
    });
  }, [errorsValidation]);
  const validateLength = (0,react.useCallback)((_value, _key, _length, _message, _focus) => {
    const error = _value.length < _length ? {
      [_key]: _message
    } : undefined;
    updateErrors(_key, error, _focus);
    return error;
  }, [rating, title, text, recommended, characteristics, agreed]);
  const validatePresence = (0,react.useCallback)((_value, _key, _message, _focus) => {
    const error = !_value ? {
      [_key]: _message
    } : undefined;
    updateErrors(_key, error, _focus);
    return error;
  }, [rating, title, text, recommended, characteristics, agreed]);
  const clearForm = (0,react.useCallback)(() => {
    setRating('');
    setTitle('');
    setText('');
    setRecommended('');
    setAgreed(false);
    setCharacteristics(reviewCharacteristics.map(_ref2 => {
      let rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["value"]);

      return rest;
    }));
  }, [reviewCharacteristics]);
  const handleSubmit = (0,react.useCallback)(e => {
    const errors = Object.assign({}, validatePresence(rating, 'rating', ratingError), validatePresence(title, 'title', titleError), validateLength(text, 'text', minTextSize, textError), validatePresence(recommended, 'recommended', recommendedError), characteristics.reduce((acc, characteristic) => Object.assign({}, acc, validatePresence(characteristic.value, characteristic.id, ratingError)), {}), validatePresence(agreed, 'agreed', agreedError));

    if (!Object.keys(errors).length) {
      onSubmit({
        rating,
        title,
        text,
        recommended,
        characteristics
      }, clearForm);
    }

    e.preventDefault();
  }, [rating, title, text, recommended, agreed, characteristics]);
  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    as: "form",
    "data-testid": "review-form"
  }, /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => {
      validatePresence(e.target.value, 'rating', ratingError, false);
      setRating(e.target.value);
    },
    ref: refs.rating,
    value: rating,
    error: errorsValidation.rating,
    type: "rating",
    label: ratingLabel,
    height: [40, 30],
    width: [40, 30],
    gap: [0, 30],
    fontSize: [4, 2],
    fontWeight: ['bold', 'regular'],
    flexDirection: ['column', 'row'],
    alignItems: "center",
    textAlign: ['center', 'right'],
    name: "rating"
  })), /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => setTitle(e.target.value),
    onFocus: () => setErrorsValidation(_ref3 => {
      let errors = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["title"]);

      return errors;
    }),
    onBlur: e => validatePresence(e.target.value, 'title', titleError, false),
    ref: refs.title,
    value: title,
    error: errorsValidation.title,
    type: "text",
    label: titleLabel,
    placeholder: titlePlaceholder,
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    textAlign: ['left', 'right']
  })), /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => setText(e.target.value),
    onFocus: () => setErrorsValidation(_ref4 => {
      let errors = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["text"]);

      return errors;
    }),
    onBlur: e => validateLength(e.target.value, 'text', 50, textError, false),
    ref: refs.text,
    value: text,
    error: errorsValidation.text,
    type: "textarea",
    label: textLabel,
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    textAlign: ['left', 'right'],
    placeholder: textPlaceholder
  })), /*#__PURE__*/react.createElement(Row, {
    borderBottomWidth: ['1px', '0px'],
    borderBottomStyle: "solid",
    borderColor: "lightSilver"
  }, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => {
      validatePresence(e.target.value, 'recommended', recommendedError, false);
      setRecommended(e.target.value);
    },
    ref: refs.recommended,
    value: recommended,
    error: errorsValidation.recommended,
    type: "recommendation",
    label: recommendedLabel,
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    alignItems: "center",
    textAlign: ['center', 'right']
  })), characteristics == null ? void 0 : characteristics.map(({
    id,
    label,
    value
  }) => /*#__PURE__*/react.createElement(Row, {
    key: id,
    borderBottomWidth: ['1px', '0px'],
    borderBottomStyle: "solid",
    borderColor: "lightSilver"
  }, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => {
      validatePresence(e.target.value, id, ratingError, false);
      setCharacteristics(characteristics.map(characteristic => {
        if (characteristic.id === id) {
          return Object.assign({}, characteristic, {
            value: e.target.value
          });
        }

        return characteristic;
      }));
    },
    name: id,
    ref: refs[id],
    value: value,
    error: errorsValidation[id],
    label: label,
    type: "rating",
    height: [30, 24],
    width: [30, 24],
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    alignItems: "center",
    textAlign: ['center', 'right']
  }))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    m: 20,
    flexDirection: ['column', 'row'],
    gap: [0, 30]
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "0.75"
  }), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "1",
    gap: "2",
    alignItems: ['center', 'start'],
    justifyContent: "space-evenly",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(atoms/* Checkbox */.XZ, {
    ref: refs.agreed,
    checked: agreed,
    onChange: e => {
      validatePresence(e.target.checked, 'agreed', agreedError, false);
      setAgreed(e.target.checked);
    }
  }, agreedLabel), errorsValidation.agreed && /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "error.base"
  }, errorsValidation.agreed))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    mY: 20,
    flexDirection: ['column', 'row'],
    gap: [0, 30]
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "0.75"
  }), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "1",
    gap: "2",
    alignItems: ['center', 'start'],
    justifyContent: "space-evenly",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    onClick: handleSubmit,
    full: true
  }, buttonLabel))));
}

ReviewForm.defaultProps = {
  agreedError: 'Por favor verifique os termos.',
  agreedLabel: 'Concordo com os termos e condições',
  buttonLabel: 'Enviar avaliação',
  ratingError: 'Clique nas estrelas para classificar!',
  ratingLabel: 'Avaliação Geral',
  recommendedError: 'Por favor selecione uma opção.',
  recommendedLabel: 'Você recomenda esse produto?',
  minTextSize: 50,
  textError: 'Mínimo de 50 caracteres.',
  textLabel: 'Avaliação',
  titleError: 'Insira o título completo corretamente.',
  titleLabel: 'Título da avaliação',
  titlePlaceholder: 'Ex. Produto Maravilhoso',
  textPlaceholder: 'Ex: Escreva exclusivamente sobre o produto. Para sugestões, reclamações ou problemas em geral, acesse nossa Central de Atendimento',
  focus: true
};
 false ? 0 : void 0;
/* harmony default export */ var review_form = (ReviewForm);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewForm/index.js


/***/ }),

/***/ 4506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ review_stats; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/review-stats.styles.js





const Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Main = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > div {
    display: flex;
    align-items: center;
  }
`;
const Score = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.bold')(props)};
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.7')(props)}px;
`;
const Description = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.0')(props)}px;
  color: ${props => (0,build_esm.getTextColor)('light')(props)};
`;
const Divider = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  border-left: 3px solid ${props => (0,build_esm.getBorderColor)('light')(props)};
  height: 90px;
  margin: 0px 24px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/review-stats.js







function ReviewStats({
  average,
  count: total,
  distribution,
  actionLabel,
  onReviewButtonClick
}) {
  const desc = total > 1 ? `${total} avaliações` : `${total} avaliação`;
  distribution.sort((a, b) => b.value - a.value);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Container, {
    mb: [3, 3, 3]
  }, /*#__PURE__*/react.createElement(Main, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Score, {
    "data-testid": "stat-score"
  }, average.toFixed(1)), /*#__PURE__*/react.createElement(esm/* Star */.Uxw, {
    width: "50px",
    height: "50px",
    color: "#FFCC03"
  })), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "stat-desc"
  }, desc)), /*#__PURE__*/react.createElement(Divider, null), /*#__PURE__*/react.createElement("ul", null, distribution == null ? void 0 : distribution.map(item => /*#__PURE__*/react.createElement(molecules/* RatingLine */.me, {
    key: item.value,
    id: item.value,
    score: item.count,
    count: item.count,
    max: total
  })))), !!actionLabel && /*#__PURE__*/react.createElement(Button/* default */.Z, {
    full: true,
    variation: "fill",
    size: "medium",
    color: "primary",
    onClick: e => onReviewButtonClick(e, {
      average,
      distribution,
      desc,
      total
    })
  }, actionLabel));
}

ReviewStats.defaultProps = {
  actionLabel: 'Quero avaliar',
  average: 0,
  count: 0,
  distribution: [],
  onReviewButtonClick: () => ({})
};
 false ? 0 : void 0;
/* harmony default export */ var review_stats = (ReviewStats);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/index.js


/***/ }),

/***/ 30143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ seller_delivery; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 6 modules
var organisms = __webpack_require__(28167);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/seller-delivery.styles.js




const Label = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  color: ${props => props.color || (0,build_esm.getTextColor)('scratched')(props)};
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.regular')(props)};
  margin-right: 4px;
  line-height: ${props => props.lineHeight || `20px`};
`;
const Link = styled_components_browser_esm["default"].label`
  color: ${props => (0,build_esm.getTextColor)('base')(props)};
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.bold')(props)};
  text-decoration: ${({
  disableClick
}) => disableClick ? 'none' : 'underline'};
  cursor: ${({
  disableClick
}) => disableClick ? 'default' : 'pointer'};
`;
const PartnerLink = styled_components_browser_esm["default"].a`
  cursor: pointer;

  svg {
    vertical-align: middle;
  }
`;
const LogoMagaluIcon = (0,styled_components_browser_esm["default"])(esm/* LogoMagalu */.ZGh).attrs(props => ({
  color: `${props.logoIconColor || (0,build_esm.getPaletteColor)('base')(props)}`,
  width: 60,
  height: 14,
  viewBox: '0 0 60 14'
}))`
  vertical-align: middle;
  margin-top: 4px;
`;
const Content = styled_components_browser_esm["default"].div`
  padding: 15px 15px;
`;
const Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.5')(props)}px;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.bold')(props)};
`;
const Offers = styled_components_browser_esm["default"].a`
  height: 20px;
  display: flex;
  align-items: center;
  margin: 28px 0;
  text-decoration: none;
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.medium')(props)};
  color: ${props => (0,build_esm.getTextColor)('primary')(props)};
  cursor: pointer;
`;
const ChevronRightIcon = (0,styled_components_browser_esm["default"])(esm/* ChevronRight */._Qn).attrs(props => ({
  color: (0,build_esm.getTextColor)('primary')(props)
}))`
  vertical-align: middle;
  width: 20px;
  height: 20px;
`;
const Detail = styled_components_browser_esm["default"].div`
  margin: 0 0 15px;
`;
const DetailLabel = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.3')(props)}px;
  font-weight: ${props => (0,build_esm.themeGet)('fontWeights.bold')(props)};
  padding: 0 0 5px;
`;
const DetailText = styled_components_browser_esm["default"].p`
  font-size: ${props => (0,build_esm.themeGet)('fontSizes.2')(props)}px;
  color: ${props => (0,build_esm.getTextColor)('greyish')(props)};
  padding: 0 0 5px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/content-box.js






const partnerProps = {
  bg: '#f0f0f2',
  borderRadius: 8,
  p: 2,
  mb: 2,
  alignItems: 'center'
};

const ContentBox = _ref => {
  let {
    id,
    delivery,
    handleLabelName,
    internationalPartner,
    partnerColor
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["id", "delivery", "handleLabelName", "internationalPartner", "partnerColor"]);

  if (!delivery && !id) return null;
  return !delivery || (id == null ? void 0 : id.toUpperCase()) === (delivery == null ? void 0 : delivery.toUpperCase()) ? /*#__PURE__*/react.createElement(atoms/* Box */.xu, internationalPartner ? partnerProps : props, /*#__PURE__*/react.createElement(Label, (0,esm_extends/* default */.Z)({}, internationalPartner ? {
    color: partnerColor,
    lineHeight: '16px'
  } : {}, {
    "data-testid": "label"
  }), "Vendido e entregue por ", handleLabelName(delivery))) : /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, /*#__PURE__*/react.createElement(Label, {
    "data-testid": "label"
  }, "Vendido por ", handleLabelName(id)), /*#__PURE__*/react.createElement(Label, {
    "data-testid": "label"
  }, "Entregue por ", handleLabelName(delivery)));
};

 false ? 0 : void 0;
ContentBox.defaultProps = {
  id: 'magazineluiza',
  delivery: 'magazineluiza',
  handleLabelName: () => {},
  internationalPartner: false
};
/* harmony default export */ var content_box = (ContentBox);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/seller-detail.js





const parseAddress = data => {
  const {
    address,
    number,
    district,
    city,
    state,
    zipcode
  } = data;
  const value = [];
  if (address && number) value.push(`${address}, ${number}`);
  if (city && state) value.push(`${district ? `${district} - ` : ''}${city}/${state}`);
  if (zipcode) value.push(`CEP: ${zipcode}`);
  return value;
};

const SellerDetail = ({
  seller,
  product,
  onOffersClick
}) => {
  const {
    id,
    description: title,
    deliveryId: delivery,
    details,
    href
  } = seller;
  const showInternationalSeller = (0,utils/* isInternationalPrice */.xx)(product == null ? void 0 : product.price);
  const addressData = parseAddress((details == null ? void 0 : details.address) || {});

  const docSeller = () => {
    return !showInternationalSeller ? {
      label: 'CNPJ',
      id: 'documentNumber',
      value: details == null ? void 0 : details.documentNumber
    } : {
      label: 'ID do Lojista',
      id: 'shippingDocumentNumber',
      value: details == null ? void 0 : details.shippingDocumentNumber
    };
  };

  const detailsParsed = [(details == null ? void 0 : details.legalName) && {
    label: 'Razão Social',
    id: 'legalName',
    value: details == null ? void 0 : details.legalName
  }, docSeller(), addressData.length && {
    label: 'Endereço',
    id: 'address',
    value: parseAddress(details == null ? void 0 : details.address)
  }];
  return /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Title, null, title), /*#__PURE__*/react.createElement(Offers, {
    href: href,
    onClick: e => onOffersClick(e, {
      id,
      delivery
    }),
    "data-testid": "offers-link"
  }, "Veja todas as ofertas dessa loja ", /*#__PURE__*/react.createElement(ChevronRightIcon, null)), detailsParsed.map((detail, index) => /*#__PURE__*/react.createElement(Detail, {
    key: `seller-detail-${index}`,
    "data-testid": "details"
  }, /*#__PURE__*/react.createElement(DetailLabel, null, detail == null ? void 0 : detail.label), Array.isArray(detail == null ? void 0 : detail.value) ? detail == null ? void 0 : detail.value.map(value => /*#__PURE__*/react.createElement(DetailText, {
    "data-testid": "details-value",
    key: `seller-value-${value}`
  }, value)) : /*#__PURE__*/react.createElement(DetailText, null, detail == null ? void 0 : detail.value))));
};

 false ? 0 : void 0;
SellerDetail.defaultProps = {
  seller: {
    id: 'magazineluiza',
    deliveryId: 'magazineluiza',
    description: 'Magalu',
    details: {}
  },
  product: {},
  onOffersClick: () => {}
};
/* harmony default export */ var seller_detail = (SellerDetail);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/magalu-companies.js

/* harmony default export */ var magalu_companies = ({
  zattini: {
    id: 'zattini',
    logo: esm/* LogoZattiniName */.fOR
  },
  netshoes: {
    id: 'netshoes',
    logo: esm/* LogoNetshoesName */.fOD
  },
  kabum: {
    id: 'kabum',
    logo: esm/* LogoKabum */.M0M
  },
  'epocacosmeticos-integra': {
    id: 'epoca',
    logo: esm/* LogoEpocaName */.uE5
  }
});
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/index.js + 2 modules
var SidebarHeader = __webpack_require__(83179);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/seller-delivery.js














const SellerDelivery = _ref => {
  let {
    showSellerDetailContent,
    onCloseModalContent,
    seller,
    product,
    onSellerClick,
    onOffersClick,
    disableSellerClick,
    disableSellerDetails,
    logoIconColor,
    showDialog,
    modal,
    internationalPartner,
    partnerColor,
    partnerLogo
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["showSellerDetailContent", "onCloseModalContent", "seller", "product", "onSellerClick", "onOffersClick", "disableSellerClick", "disableSellerDetails", "logoIconColor", "showDialog", "modal", "internationalPartner", "partnerColor", "partnerLogo"]);

  const {
    id,
    description: title,
    deliveryId: delivery
  } = seller;
  const [showSellerDetail, setShowSellerDetail] = (0,react.useState)(showSellerDetailContent);

  const handleShowDetails = e => {
    onSellerClick(e, {
      id,
      delivery
    });
    setShowSellerDetail(!disableSellerDetails);
  };

  const handleCloseModal = () => {
    setShowSellerDetail(false);
    onCloseModalContent();
  };

  react.useEffect(() => {
    setShowSellerDetail(showSellerDetailContent);
  }, [showSellerDetailContent]);

  const handleLabelName = label => {
    if (internationalPartner && partnerLogo) {
      return /*#__PURE__*/react.createElement(PartnerLink, {
        title: `Logo ${delivery}`,
        "data-testid": `${delivery}logo`,
        children: /*#__PURE__*/react.createElement(esm/* GenericImageIcon */.RdR, {
          href: partnerLogo,
          width: 77,
          height: 16
        }),
        onClick: disableSellerClick ? null : handleShowDetails
      });
    }

    if (label === constants/* DEFAULT_SELLER */.ig) {
      return /*#__PURE__*/react.createElement(LogoMagaluIcon, {
        title: "Logo magalu",
        "data-testid": "magalogo",
        logoIconColor: logoIconColor
      });
    }

    if (magalu_companies[label]) {
      const {
        id: partnerId,
        logo: Logo
      } = magalu_companies[label];
      return /*#__PURE__*/react.createElement(PartnerLink, {
        title: `Logo ${partnerId}`,
        "data-testid": `${partnerId}logo`,
        children: /*#__PURE__*/react.createElement(Logo, {
          preserveAspectRatio: true
        }),
        onClick: disableSellerClick ? null : handleShowDetails
      });
    }

    return /*#__PURE__*/react.createElement(Link, {
      onClick: disableSellerClick ? null : handleShowDetails,
      disableClick: disableSellerClick,
      children: title || delivery,
      "data-testid": "link"
    });
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(content_box, (0,esm_extends/* default */.Z)({
    id: id,
    delivery: delivery,
    handleLabelName: handleLabelName,
    internationalPartner: internationalPartner,
    partnerColor: partnerColor
  }, props)), !disableSellerClick && !showDialog && /*#__PURE__*/react.createElement(organisms/* Sidebar */.YE, {
    direction: "right",
    visible: showSellerDetail,
    onClickOutside: handleCloseModal,
    fullScreen: true,
    portal: true
  }, /*#__PURE__*/react.createElement(SidebarHeader/* default */.Z, {
    label: modal.title || 'Informações da loja parceira',
    align: "left",
    leftButton: {
      icon: 'back',
      title: 'Voltar para a pagina do produto',
      onClick: handleCloseModal
    }
  }), modal.content || /*#__PURE__*/react.createElement(seller_detail, {
    seller: seller,
    product: product,
    onOffersClick: onOffersClick
  })), !disableSellerClick && !disableSellerDetails && showDialog && /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    visible: showSellerDetail,
    onClickOutside: handleCloseModal,
    position: "center",
    type: "responsive",
    showClose: true,
    title: modal.title,
    titleStyle: modal.titleStyle
  }, modal.content || /*#__PURE__*/react.createElement(seller_detail, {
    seller: seller,
    product: product,
    onOffersClick: onOffersClick
  })));
};

 false ? 0 : void 0;
SellerDelivery.defaultProps = {
  product: {},
  seller: {
    id: 'magazineluiza',
    deliveryId: 'magazineluiza',
    description: 'Magalu'
  },
  onSellerClick: () => {},
  onOffersClick: () => {},
  disableSellerClick: false,
  onCloseModalContent: () => ({}),
  showSellerDetailContent: false,
  disableSellerDetails: false,
  logoIconColor: '',
  showDialog: false,
  modal: {
    title: ''
  },
  internationalPartner: false
};
/* harmony default export */ var seller_delivery = (SellerDelivery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js


/***/ }),

/***/ 2334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ shipping_list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ShippingList/shipping-list.js







const ShippingList = _ref => {
  let {
    items,
    currency
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["items", "currency"]);

  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, items.map((shippingItem, index) => /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    key: `shipping-item-${index}`
  }, !!index && /*#__PURE__*/react.createElement(atoms/* HorizontalRule */.bo, null), /*#__PURE__*/react.createElement(molecules/* ShippingItem */.KI, (0,esm_extends/* default */.Z)({
    currency: currency
  }, shippingItem)))));
};

ShippingList.defaultProps = {
  items: [],
  currency: 'BRL'
};
 false ? 0 : void 0;
/* harmony default export */ var shipping_list = (ShippingList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ShippingList/index.js


/***/ }),

/***/ 75335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ showcase; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/index.js + 2 modules
var Card = __webpack_require__(27439);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/showcase.styles.js






const titleStyle = styled_components_browser_esm.css`
  color: ${props => (0,esm.getTextColor)('base')(props)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
`;
const container = {
  miniature: styled_components_browser_esm.css`
    display: grid;
    padding: 8px 2px;
  `,
  list: styled_components_browser_esm.css`
    display: grid;
    grid-template-columns: 1fr 2fr;
    padding: 16px;
  `,
  gallery: styled_components_browser_esm.css``,
  none: styled_components_browser_esm.css`
    display: contents;
  `,
  button: styled_components_browser_esm.css`
    display: block;
    padding: 16px 16px 6px;
  `
};
const imgContainerDisplay = {
  miniature: styled_components_browser_esm.css`
    height: 20vw;
    justify-content: flex-end;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
    }
  `,
  list: styled_components_browser_esm.css`
    justify-content: flex-start;
    padding-top: 4px;
    min-height: 25vw;
  `,
  gallery: styled_components_browser_esm.css`
    height: 32vw;
    justify-content: flex-end;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
    }
  `
};
const Display = (0,styled_components_browser_esm["default"])(Card/* default */.ZP)`
  background-color: ${props => (0,esm.getPaletteColor)('background.lighter')(props)};
  padding: 0;
  ${({
  displayMode
}) => displayMode && container[displayMode]}
`;
const ImageContainer = styled_components_browser_esm["default"].div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-right: ${props => (0,esm.themeGet)('space.2')(props)}px;
  ${({
  displayMode
}) => displayMode && imgContainerDisplay[displayMode]}
`;
const TitleDisplay = styled_components_browser_esm["default"].div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  grid-column-start: ${({
  betterOffer
}) => betterOffer && 2};
  ${({
  highlight,
  highlightType,
  sponsored
}) => highlight && !highlightType ? styled_components_browser_esm.css`
          margin: ${(0,esm.themeGet)('space.0')}px ${(0,esm.themeGet)('space.2')}px;
        ` : styled_components_browser_esm.css`
          margin-bottom: ${sponsored ? (0,esm.themeGet)('space.2') : (0,esm.themeGet)('space.3')}px;
        `};
`;
const Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(({
  highlight,
  fontSize
}) => ({
  fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : [highlight ? 1 : 2, 4, 5],
  lineHeight: 'display',
  fontWeight: 'medium'
}))`
  ${titleStyle}
  ${index_esm.typography}

  & > span {
    font-weight: ${props => (0,esm.themeGet)('fontWeights.bold')(props)};
  }
`;
const ButtonTitle = styled_components_browser_esm["default"].h2`
  ${titleStyle}
  height: 32px;
  line-height: ${props => (0,esm.themeGet)('lineHeights.plus')(props)}px;
  font-size: ${props => (0,esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,esm.themeGet)('fontWeights.regular')(props)};
  margin: 0 0 4px 0;
`;
const ProductCard = styled_components_browser_esm["default"].div`
  display: grid;
  grid-template-columns: 1fr 2fr;
`;
const TextHighlight = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(() => ({
  fontSize: [1, 4, 5],
  lineHeight: 'display',
  fontWeight: 'regular'
}))`
  ${titleStyle}
  ${index_esm.typography}
`;
const Content = styled_components_browser_esm["default"].div`
  display: grid;
`;
const Container = styled_components_browser_esm["default"].div`
  box-shadow: ${({
  exhibition
}) => exhibition === 'highlight' ? '0 4px 10px 0 rgba(0, 0, 0, 0.11)' : 'unset'};
  border-radius: ${({
  exhibition
}) => exhibition === 'highlight' && '4px'};
  overflow: hidden;
  ${({
  exhibition
}) => exhibition === 'betteroffer' && styled_components_browser_esm.css`
      display: grid;
      grid-template-rows: auto auto;
      padding: 24px 0;
      grid-template-columns: 1fr minmax(auto, 1376px) 1fr;
    `}
  ${index_esm.space}
  ${index_esm.color}
  ${index_esm.layout}
  ${index_esm.border}
`;
const ProductCardContent = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)`
  flex: 1;
  flex: 0 0 calc(100% / 4);
  border-right: ${(0,esm.themeGet)('borders.0')};
  border-width: 2px;
`;
const SponsoredSubTitle = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(() => ({
  fontSize: 0,
  color: 'light',
  marginTop: 1
}))``;
const ShowcaseContent = styled_components_browser_esm["default"].div`
  grid-column-start: 2;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js + 3 modules
var ProductList = __webpack_require__(98284);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/highlight-title.js




const HighlightTitle = ({
  title,
  titleAs,
  titleSize,
  highlightType,
  showSponsoredSubTitle,
  betterOffer
}) => {
  const [prefix, highlight = '', suffix = ''] = title.split('"');
  const cleanSuffix = suffix.replace(', ', '');
  return /*#__PURE__*/react.createElement(TitleDisplay, {
    highlight: highlight,
    highlightType: highlightType,
    sponsored: showSponsoredSubTitle,
    betterOffer: betterOffer
  }, highlightType ? /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "product-title-head"
  }, prefix, " ", /*#__PURE__*/react.createElement("span", null, highlight), " ", cleanSuffix) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    highlight: highlight,
    "data-testid": "product-title-head"
  }, prefix), !!highlight && /*#__PURE__*/react.createElement(TextHighlight, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "text-highlight"
  }, highlight), !!cleanSuffix && /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "text-suffix"
  }, cleanSuffix)), showSponsoredSubTitle && /*#__PURE__*/react.createElement(SponsoredSubTitle, {
    "data-testid": "sponsored-tag"
  }, "Patrocinados"));
};

 false ? 0 : void 0;
HighlightTitle.defaultProps = {
  title: '',
  titleAs: 'h2',
  highlightType: false,
  showSponsoredSubTitle: false,
  betterOffer: false
};
/* harmony default export */ var highlight_title = (HighlightTitle);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/rank.js







const Rank = _ref => {
  let {
    data,
    title,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showDiscountOnlyCashInfo,
    showDiscount
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "title", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showDiscountOnlyCashInfo", "showDiscount"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleSize: titleSize,
    titleAs: titleAs
  }), /*#__PURE__*/react.createElement(ProductList/* default */.Z, (0,esm_extends/* default */.Z)({
    data: data,
    displayMode: "list",
    enableShadow: false,
    exhibition: "rank",
    imageAltPrefix: imageAltPrefix,
    titleAs: productTitleAs,
    showInCashInfo: true,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount
  }, props)));
};

 false ? 0 : void 0;
/* harmony default export */ var rank = (Rank);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/list.js







const List = _ref => {
  let {
    data,
    title,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showFullListBtn,
    showMoreBtn,
    onClickLoadMore,
    showDiscountOnlyCashInfo,
    showDiscount,
    showSponsoredSubTitle
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "title", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showFullListBtn", "showMoreBtn", "onClickLoadMore", "showDiscountOnlyCashInfo", "showDiscount", "showSponsoredSubTitle"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleSize: titleSize,
    titleAs: titleAs,
    showSponsoredSubTitle: showSponsoredSubTitle
  }), /*#__PURE__*/react.createElement(ProductList/* default */.Z, (0,esm_extends/* default */.Z)({
    data: data,
    displayMode: "gallery",
    enableShadow: false,
    exhibition: "list",
    imageAltPrefix: imageAltPrefix,
    titleAs: productTitleAs,
    showFullListBtn: showFullListBtn,
    showMoreBtn: showMoreBtn,
    onClickLoadMore: onClickLoadMore,
    showInCashInfo: true,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo
  }, props)));
};

 false ? 0 : void 0;
/* harmony default export */ var list = (List);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/highlight.js









const Highlight = _ref => {
  let {
    data,
    highlight,
    title,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showDiscount,
    showDiscountOnlyCashInfo
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "highlight", "title", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showDiscount", "showDiscountOnlyCashInfo"]);

  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${highlight.title}` : highlight.title;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Display, {
    as: "div",
    displayMode: "list",
    "data-testid": "product-card-container",
    hideLinkBorder: false
  }, /*#__PURE__*/react.createElement(ImageContainer, {
    displayMode: "list"
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    src: highlight.image,
    alt: imageAlt,
    lazy: true,
    offset: 2
  })), /*#__PURE__*/react.createElement(Content, {
    displayMode: "gallery",
    "data-testid": "product-card-content"
  }, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize
  }))), /*#__PURE__*/react.createElement(ProductList/* default */.Z, (0,esm_extends/* default */.Z)({
    data: data,
    displayMode: "gallery",
    enableShadow: false,
    exhibition: "highlight",
    imageAltPrefix: imageAltPrefix,
    titleAs: productTitleAs,
    showInCashInfo: true,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount
  }, props)));
};

 false ? 0 : void 0;
/* harmony default export */ var highlight = (Highlight);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/button.js








const Button = ({
  data,
  button,
  title,
  titleAs,
  titleSize,
  imageAltPrefix,
  productTitleAs,
  onClick,
  onMouseDown
}) => {
  const [highlight] = data;
  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${highlight.title}` : highlight == null ? void 0 : highlight.title;
  return /*#__PURE__*/react.createElement(Display, {
    displayMode: "button",
    "data-testid": "product-card-container",
    hideLinkBorder: false,
    as: "div"
  }, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize
  }), /*#__PURE__*/react.createElement(ProductCard, null, /*#__PURE__*/react.createElement(ImageContainer, {
    displayMode: "list"
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    src: highlight == null ? void 0 : highlight.image,
    alt: imageAlt,
    lazy: true,
    offset: 2
  })), /*#__PURE__*/react.createElement(Content, {
    displayMode: "none",
    "data-testid": "product-card-content"
  }, /*#__PURE__*/react.createElement(TitleDisplay, {
    as: productTitleAs
  }, /*#__PURE__*/react.createElement(ButtonTitle, null, highlight == null ? void 0 : highlight.title)))), /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    "data-testid": "showcase-button",
    onClick: e => onClick(e, highlight),
    onMouseDown: e => onMouseDown(e, highlight),
    color: "secondary",
    startIcon: /*#__PURE__*/react.createElement(build_esm/* ShoppingBagFast */.tuM, {
      width: 32,
      height: 32
    }),
    m: '10px 0',
    full: true
  }, (button == null ? void 0 : button.label) || 'RETOMAR SUA COMPRA'));
};

 false ? 0 : void 0;
Button.defaultProps = {
  onMouseDown: () => {}
};
/* harmony default export */ var exhibitions_button = (Button);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 18 modules
var organisms_ProductCard = __webpack_require__(47719);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/carousel.js










const Carousel = _ref => {
  let {
    title,
    titleAs,
    titleSize,
    data,
    highlight,
    slidesPerView,
    showDiscount,
    showDiscountOnlyCashInfo,
    showSponsoredSubTitle,
    offerTimerProps
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["title", "titleAs", "titleSize", "data", "highlight", "slidesPerView", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "offerTimerProps"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize,
    highlightType: !!highlight,
    showSponsoredSubTitle: showSponsoredSubTitle
  }), /*#__PURE__*/react.createElement(Flex/* default */.Z, null, highlight && /*#__PURE__*/react.createElement(ProductCardContent, {
    slidesPerView: slidesPerView
  }, /*#__PURE__*/react.createElement(organisms_ProductCard/* default */.Z, (0,esm_extends/* default */.Z)({}, highlight, {
    displayMode: "gallery",
    showInCashInfo: true,
    titleAs: "h3",
    fullHeight: true,
    imageAltPrefix: "",
    imgLazyLoading: true,
    imageWidth: props.imageWidth,
    imageHeight: props.imageHeight,
    showRating: false,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount,
    key: `product-hightlight${highlight.variationId || highlight.id}`,
    offerTimerProps: offerTimerProps,
    enableHover: true
  }))), /*#__PURE__*/react.createElement(ProductCarousel/* default */.Z, (0,esm_extends/* default */.Z)({
    products: data,
    slidesPerView: highlight ? slidesPerView - 1 : slidesPerView,
    enableHover: !highlight,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount,
    offerTimerProps: offerTimerProps
  }, props))));
};

Carousel.defaultProps = {
  slidesPerView: 4,
  hidePriceWhen: undefined,
  hideShippingTagWhen: undefined
};
 false ? 0 : void 0;
/* harmony default export */ var carousel = (Carousel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/better-offer.js








const BetterOffer = _ref => {
  let {
    title,
    titleAs,
    titleSize,
    data,
    highlight,
    slidesPerViewBetterOffer,
    showSponsoredSubTitle,
    showButton,
    buttonProps
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["title", "titleAs", "titleSize", "data", "highlight", "slidesPerViewBetterOffer", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "showButton", "buttonProps"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize,
    highlightType: !!highlight,
    showSponsoredSubTitle: showSponsoredSubTitle,
    betterOffer: true
  }), /*#__PURE__*/react.createElement(ShowcaseContent, null, /*#__PURE__*/react.createElement(ProductCarousel/* default */.Z, (0,esm_extends/* default */.Z)({
    products: data,
    slidesPerView: slidesPerViewBetterOffer,
    enableHover: !highlight,
    showDiscountOnlyCashInfo: false,
    showDiscount: false,
    fullHeight: false,
    exhibition: "betteroffer",
    gutter: 24,
    displayMode: "list",
    showRating: false,
    showOfferTimer: true,
    showPartialNextSlide: true,
    cardType: "horizontal",
    show: true,
    showBorder: true,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: true
  }, props))));
};

BetterOffer.defaultProps = {
  slidesPerViewBetterOffer: 2,
  showButton: false,
  buttonProps: {}
};
 false ? 0 : void 0;
/* harmony default export */ var better_offer = (BetterOffer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/index.js






const exhibitions = {
  rank: rank,
  list: list,
  highlight: highlight,
  button: exhibitions_button,
  carousel: carousel,
  betteroffer: better_offer
};
/* harmony default export */ var Showcase_exhibitions = (exhibitions);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/showcase.js






const Showcase = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _ref;

  const {
    data,
    onClick,
    onMouseDown,
    onProductView,
    jsonLD,
    exhibition,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showFullListBtn,
    showMoreBtn,
    onClickLoadMore,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    showSponsoredSubTitle,
    slidesPerViewBetterOffer,
    showButton,
    buttonProps
  } = props,
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["data", "onClick", "onMouseDown", "onProductView", "jsonLD", "exhibition", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showFullListBtn", "showMoreBtn", "onClickLoadMore", "showInCashInfo", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "slidesPerViewBetterOffer", "showButton", "buttonProps"]);

  (_ref = ref) !== null && _ref !== void 0 ? _ref : ref = (0,react.useRef)(null);
  const Exhibition = Showcase_exhibitions[exhibition] === undefined ? Showcase_exhibitions.rank : Showcase_exhibitions[exhibition];
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref,
    exhibition: exhibition
  }, rest), /*#__PURE__*/react.createElement(Exhibition, (0,esm_extends/* default */.Z)({
    data: data.products,
    title: data.title,
    highlight: data.highlight,
    button: data.button,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onProductView: onProductView,
    jsonLD: jsonLD,
    titleAs: titleAs,
    titleSize: titleSize,
    productTitleAs: productTitleAs,
    imageAltPrefix: imageAltPrefix,
    showFullListBtn: showFullListBtn,
    slidesPerViewBetterOffer: slidesPerViewBetterOffer,
    showMoreBtn: showMoreBtn,
    onClickLoadMore: onClickLoadMore,
    showInCashInfo: showInCashInfo,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showSponsoredSubTitle: showSponsoredSubTitle,
    showButton: showButton,
    buttonProps: buttonProps
  }, rest)));
});
Showcase.defaultProps = {
  data: {
    title: null,
    products: []
  },
  onClick: () => false,
  onMouseDown: () => false,
  onProductView: () => {},
  exhibition: 'rank',
  jsonLD: true,
  titleAs: 'h2',
  productTitleAs: 'h3',
  imageAltPrefix: '',
  showFullListBtn: false,
  showMoreBtn: false,
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: false,
  showSponsoredSubTitle: false,
  slidesPerViewBetterOffer: 2,
  showButton: false,
  buttonProps: {},
  hidePriceWhen: undefined,
  hideShippingTagWhen: undefined
};
 false ? 0 : void 0;
Showcase.displayName = 'Showcase';
/* harmony default export */ var showcase = (Showcase);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/index.js


/***/ }),

/***/ 83179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ sidebar_header; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/sidebar-header.styles.js




const handleGridAlign = {
  left: styled_components_browser_esm.css`
    grid-template-columns: auto repeat(1, auto) 1fr;
  `,
  right: styled_components_browser_esm.css`
    grid-template-columns: 1fr repeat(1, auto) auto;
  `,
  default: styled_components_browser_esm.css`
    grid-template-columns: 1fr repeat(1, auto) 1fr;
  `
};
const Title = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  align-self: center;
  font-weight: 500;
`;
const LeftButton = styled_components_browser_esm["default"].div`
  margin-right: auto;
`;
const Container = styled_components_browser_esm["default"].div`
  display: grid;
  ${props => handleGridAlign[props == null ? void 0 : props.align] || handleGridAlign.default}
  gap: 0 10px;
  padding: 20px 16px;
  border-bottom: 1px solid ${props => (0,build_esm.getBackgroundColor)('darker')(props)};
  ${index_esm.space}
  ${index_esm.color}
  ${index_esm.layout}
  ${index_esm.border}
  ${index_esm.borderWidth}
  ${index_esm.borderStyle}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/sidebar-header.js






const Icons = {
  close: esm/* Close */.x8P,
  back: esm/* ArrowBack */.xhZ
};

const SidebarHeader = _ref => {
  let {
    label,
    align,
    fontSize,
    leftButton,
    showCloseButton
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["label", "align", "fontSize", "leftButton", "showCloseButton"]);

  const {
    icon,
    title,
    onClick,
    iconColor = '#8c8c8c'
  } = leftButton;
  const LeftIcon = Icons[icon || 'close'];
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    align: align,
    "data-testid": "sidebar-header"
  }), /*#__PURE__*/react.createElement(LeftButton, null, showCloseButton && /*#__PURE__*/react.createElement(LeftIcon, {
    color: iconColor,
    role: "button",
    title: title,
    "data-testid": `${icon}-button`,
    onClick: onClick
  })), /*#__PURE__*/react.createElement(Title, (0,esm_extends/* default */.Z)({
    fontSize: fontSize
  }, props, {
    "data-testid": "title"
  }), label));
};

 false ? 0 : void 0;
SidebarHeader.defaultProps = {
  align: 'center',
  fontSize: 1,
  leftButton: {
    icon: 'close',
    onClick: () => {}
  },
  showCloseButton: true
};
/* harmony default export */ var sidebar_header = (SidebarHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/index.js


/***/ }),

/***/ 70615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ SidebarHeader/* default */.Z; },
  "Z": function() { return /* binding */ organisms_Sidebar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(39879);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/index.js + 5 modules
var Item = __webpack_require__(81572);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/sidebar.styles.js






const displayDirections = {
  left: styled_components_browser_esm.css`
    left: 0;
    transform: ${({
    visible
  }) => visible ? 'translateX(0)' : 'translateX(-100%)'};
  `,
  right: styled_components_browser_esm.css`
    right: 0;
    transform: ${({
    visible
  }) => visible ? 'translateX(0)' : 'translateX(100%)'};
  `
};
const Container = styled_components_browser_esm["default"].aside`
  z-index: ${props => (0,esm.themeGet)('zIndices.2')(props)};
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
`;
const Header = (0,styled_components_browser_esm["default"])(Item/* default */.Z).attrs(props => ({
  borderBottom: `1px solid ${(0,esm.getBackgroundColor)('darker')(props)}`
}))``;
const Content = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(_ref => {
  let {
    fullScreen
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["visible", "fullScreen"]);

  return {
    backgroundColor: (0,esm.getBackgroundColor)((props == null ? void 0 : props.bg) || 'lighter')(props),
    zIndex: (0,esm.themeGet)('zIndices.3')(props),
    width: fullScreen ? '100%' : '80%',
    overflowX: 'hidden',
    position: 'fixed',
    overflowY: 'auto',
    textAlign: 'left',
    display: 'block',
    height: '100vh',
    // eslint-disable-next-line no-dupe-keys
    height: '100svh',
    top: 0
  };
})`
  ${index_esm.color}

  ${({
  direction
}) => displayDirections[direction] || displayDirections.right}
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
  transition: ${({
  timeTransition
}) => `transform ${timeTransition}s ease-in-out`};

  /* mobile native toolbar */
  padding-bottom: 54px;
`;
const Overlay = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(_ref2 => {
  let {
    visible
  } = _ref2,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["visible"]);

  return {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: (0,esm.themeGet)('zIndices.2')(props),
    opacity: Number(visible),
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    top: 0
  };
})`
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
  transition: visibility 0s, opacity 0.3s linear;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Portal/index.js + 1 modules
var Portal = __webpack_require__(75851);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/index.js + 2 modules
var SidebarHeader = __webpack_require__(83179);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/sidebar-header.js







const sidebar_header_SidebarHeader = _ref => {
  let {
    children,
    variant,
    startIcon,
    fontSize,
    fontWeight,
    textAlign,
    ariaLabel,
    fill,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "variant", "startIcon", "fontSize", "fontWeight", "textAlign", "ariaLabel", "fill", "onClick"]);

  return /*#__PURE__*/react.createElement(Header, (0,esm_extends/* default */.Z)({
    variant: variant,
    scale: "large",
    startIcon: startIcon && /*#__PURE__*/react.createElement(build_esm/* Icon */.JO$, {
      name: startIcon,
      "aria-label": ariaLabel,
      fill: fill,
      onClick: onClick,
      "data-testid": "sidebar-header-icon"
    }),
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    "data-testid": "sidebar-header"
  }, props), children);
};

 false ? 0 : void 0;
sidebar_header_SidebarHeader.defaultProps = {
  children: null,
  variant: 'transparent',
  startIcon: 'ArrowBack',
  fontSize: 1,
  fontWeight: 'medium',
  textAlign: 'center',
  ariaLabel: 'fechar sidebar',
  fill: 'currentColor',
  onClick: () => {}
};
/* harmony default export */ var sidebar_header = (sidebar_header_SidebarHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/sidebar.js










const withPortal = children => /*#__PURE__*/react.createElement(Portal/* default */.Z, {
  id: "portal-sidebar"
}, children);

const SidebarWrapper = _ref => {
  let {
    portal = false
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["portal"]);

  const Component = /*#__PURE__*/react.createElement(Sidebar, props);
  return portal ? withPortal(Component) : Component;
};

const Sidebar = _ref2 => {
  let {
    children,
    visible,
    direction,
    timeTransition,
    onClickOutside,
    headerTitle,
    fullScreen
  } = _ref2,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["children", "visible", "direction", "timeTransition", "onClickOutside", "headerTitle", "fullScreen"]);

  const contentRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    var _contentRef$current;

    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = visible ? 'hidden' : originalStyle;
    if (contentRef != null && (_contentRef$current = contentRef.current) != null && _contentRef$current.scrollTop) contentRef.current.scrollTop = 0;
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [visible]);
  (0,react.useEffect)(() => {
    (0,lib/* forceVisible */.Iq)();
  }, [children]);
  return /*#__PURE__*/react.createElement(Container, {
    visible: visible,
    "data-testid": "sidebar"
  }, /*#__PURE__*/react.createElement(Content, (0,esm_extends/* default */.Z)({
    forwardRef: contentRef,
    visible: visible,
    direction: direction,
    timeTransition: timeTransition,
    fullScreen: fullScreen,
    "data-testid": "content"
  }, props), headerTitle && /*#__PURE__*/react.createElement(SidebarHeader/* default */.Z, {
    label: headerTitle,
    leftButton: {
      onClick: onClickOutside
    }
  }), children), /*#__PURE__*/react.createElement(Overlay, {
    "aria-hidden": "true",
    visible: visible,
    onClick: onClickOutside,
    "data-testid": "overlay"
  }));
};

 false ? 0 : void 0;
Sidebar.defaultProps = {
  direction: 'left',
  timeTransition: 0.3,
  headerTitle: null,
  fullScreen: false,
  visible: false,
  onClickOutside: () => {}
};
SidebarWrapper.Header = sidebar_header;
/* harmony default export */ var sidebar = (SidebarWrapper);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js



/* harmony default export */ var organisms_Sidebar = (sidebar);

/***/ }),

/***/ 37215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ tag_international; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js + 2 modules
var Chip = __webpack_require__(17781);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/tag-international.styles.js


const variantionsSize = {
  xsmall: {
    size: 'xsmall',
    width: '15px',
    height: '15px',
    minWidth: '152px',
    maxWidth: '152px',
    fontSize: 0
  },
  small: {
    size: 'small',
    width: '17px',
    height: '17px',
    minWidth: '153px',
    maxWidth: '153px',
    fontSize: 1
  },
  medium: {
    size: 'medium',
    width: '20px',
    height: '18px',
    minWidth: '160px',
    maxWidth: '160px',
    fontSize: 1
  }
};
const Container = (0,styled_components_browser_esm["default"])(Chip/* default */.Z).attrs(({
  variant,
  startIcon
}) => ({
  bg: 'magabluLight',
  fontSize: 0,
  startIcon,
  fontWeight: 'medium',
  gridGap: 1,
  borderRadius: 8,
  mb: 2,
  mt: 2,
  color: 'primary',
  justify: 'start',
  padding: '2px 8px',
  minWidth: variantionsSize[variant].minWidth,
  maxWidth: variantionsSize[variant].maxWidth,
  textMaxWidth: 'auto',
  size: variantionsSize[variant].size
}))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/tag-international.js





function TagInternational({
  variant
}) {
  return /*#__PURE__*/react.createElement(Container, {
    variant: variant,
    "data-testid": "productCard-international-tag",
    startIcon: /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: "Airplane",
      fill: "#0086FF",
      width: variantionsSize[variant].width,
      height: variantionsSize[variant].height
    })
  }, "Compra Internacional");
}

TagInternational.defaultProps = {
  variant: 'xsmall'
};
 false ? 0 : void 0;
/* harmony default export */ var tag_international = (TagInternational);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js


/***/ }),

/***/ 35306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ text_list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/text-list.styles.js



const variationsList = {
  default: styled_components_browser_esm.css`
    flex-direction: column;
    word-break: break-word;
    min-width: 280px;
  `,
  flex: styled_components_browser_esm.css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    ${(0,esm.getMediaQuery)('small')} {
      justify-content: left;
    }
  `,
  inline: styled_components_browser_esm.css`
    display: inline;
    font-size: inherit;
    line-height: normal;
  `
};
const variationsItem = {
  flex: styled_components_browser_esm.css`
    display: inline-block;
    padding: ${(0,esm.themeGet)('space.3')}px ${(0,esm.themeGet)('space.2')}px;
    ${(0,esm.getMediaQuery)('small')} {
      width: 150px;
      padding: unset;
    }
  `,
  inline: styled_components_browser_esm.css`
    display: inline-block;
    margin-right: ${(0,esm.themeGet)('space.4')}px;
    font-size: inherit;
    & a {
      display: inline-block;
      font-size: inherit;
      line-height: normal;
    }
  `
};
const variationTitle = {
  default: styled_components_browser_esm.css`
    color: ${props => (0,esm.getTextColor)('base')(props)};
    padding-bottom: ${(0,esm.themeGet)('space.3')}px;
    line-height: normal;
  `,
  inline: styled_components_browser_esm.css`
    display: inline-block;
    margin-right: ${(0,esm.themeGet)('space.3')}px;
    font-size: inherit;
  `
};
const Container = (0,styled_components_browser_esm["default"])(atoms/* Box */.xu).attrs(props => Object.assign({
  p: 3,
  textAlign: 'left',
  borderRadius: 'default'
}, props))``;
const Title = (0,styled_components_browser_esm["default"])(atoms/* Heading */.X6)`
  ${props => variationTitle[props.variation] || variationTitle.default};
`;
const HorizontalRule = (0,styled_components_browser_esm["default"])(atoms/* HorizontalRule */.bo)`
  ${(0,esm.getMediaQuery)('small')} {
    display: none;
  }
`;
const List = styled_components_browser_esm["default"].ul`
  list-style-position: inside;
  display: flex;
  justify-content: space-around;
  ${props => variationsList[props.variation] || variationsList.default};
`;
const Item = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv).attrs(() => ({
  forwardedAs: 'li',
  fontSize: 2,
  color: 'scratched',
  lineHeight: 'big'
}))`
  list-style-type: ${({
  hideListPoint
}) => hideListPoint ? 'none' : 'disc'};
  ${props => variationsItem[props.variation] || variationsItem.default};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/text-list.js








const TextList = _ref => {
  let {
    hideListPoint,
    limitListItems,
    list,
    handleClickLink,
    showAllItems,
    showMoreLabel,
    title,
    titleAs,
    typeList
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["hideListPoint", "limitListItems", "list", "handleClickLink", "showAllItems", "showMoreLabel", "title", "titleAs", "typeList"]);

  const [showAll, setShowAll] = (0,react.useState)(showAllItems);
  const [items, setItems] = (0,react.useState)(list.slice(0, limitListItems));

  const handleShowMore = () => {
    setShowAll(true);
    setItems(list);
  };

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "text-list-container"
  }, props, {
    variation: typeList
  }), title && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Title, {
    "data-testid": "text-list-title",
    as: titleAs,
    variation: typeList
  }, title), typeList !== 'inline' && /*#__PURE__*/react.createElement(HorizontalRule, {
    variation: typeList
  })), /*#__PURE__*/react.createElement(List, {
    "data-testid": "text-list-ul",
    variation: typeList
  }, items.map((line, index) => /*#__PURE__*/react.createElement(Item, {
    variation: typeList,
    hide: !showAll && index >= limitListItems,
    key: index,
    "data-testid": "text-list-text",
    hideListPoint: hideListPoint
  }, /*#__PURE__*/react.createElement(molecules/* DynamicText */.g0, {
    data: line,
    handleClickLink: handleClickLink
  })))), !showAll && items.length >= limitListItems && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(HorizontalRule, null), /*#__PURE__*/react.createElement(atoms/* Item */.ck, {
    fontWeight: "medium",
    fontSize: 1,
    color: "text.primary",
    fill: "text.primary",
    startIcon: "ChevronDownCircle",
    variant: "transparent",
    gap: 1,
    centered: true,
    onClick: handleShowMore,
    "data-testid": "term-list-more"
  }, showMoreLabel)));
};

TextList.defaultProps = {
  hideListPoint: false,
  limitListItems: 20,
  list: [],
  handleClickLink: () => {},
  showAllItems: true,
  showMoreLabel: 'veja mais',
  title: null,
  titleAs: 'h1',
  typeList: 'default'
};
 false ? 0 : void 0;
/* harmony default export */ var text_list = (TextList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/index.js


/***/ }),

/***/ 41323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ zip_code_bar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeText/index.js + 2 modules
var ZipcodeText = __webpack_require__(1587);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/zip-code-bar.styles.js




const Container = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'background.primaryDark',
  padding: 1
}))``;
const ChevronRightIcon = (0,styled_components_browser_esm["default"])(build_esm/* ChevronRight */._Qn).attrs(props => ({
  color: (0,esm.getTextColor)('lightest')(props)
}))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/zip-code-bar.js







const ZipcodeBar = _ref => {
  let {
    text,
    defaultText,
    zipcode,
    state,
    city,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["text", "defaultText", "zipcode", "state", "city", "onClick"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    onClick: onClick,
    "data-testid": "container"
  }, props), /*#__PURE__*/react.createElement(ZipcodeText/* default */.Z, {
    city: city,
    defaultText: defaultText,
    state: state,
    text: text,
    zipcode: zipcode,
    iconHeight: 18,
    iconWidth: 20
  }), /*#__PURE__*/react.createElement(ChevronRightIcon, null));
};

ZipcodeBar.defaultProps = {
  zipcode: undefined,
  state: undefined,
  city: undefined
};
 false ? 0 : void 0;
/* harmony default export */ var zip_code_bar = (ZipcodeBar);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/index.js


/***/ }),

/***/ 28167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dO": function() { return /* reexport */ AttributeList/* default */.Z; },
  "G4": function() { return /* reexport */ FilterItemAttribute/* default */.Z; },
  "jm": function() { return /* reexport */ FilterItemContainer/* default */.Z; },
  "aw": function() { return /* reexport */ FilterItemPrice/* default */.Z; },
  "pZ": function() { return /* reexport */ FilterItemReview/* default */.Z; },
  "f4": function() { return /* reexport */ HeaderLinks/* default */.Z; },
  "DH": function() { return /* reexport */ LinksMenu/* default */.Z; },
  "Il": function() { return /* reexport */ ProductCard/* default */.Z; },
  "zT": function() { return /* reexport */ ProductReviewGallery/* default */.Z; },
  "Qp": function() { return /* reexport */ ProductReviewPopup/* default */.Z; },
  "Ak": function() { return /* reexport */ review_card; },
  "Ym": function() { return /* reexport */ review_characteristics; },
  "fP": function() { return /* reexport */ SellerDelivery/* default */.Z; },
  "u0": function() { return /* reexport */ ShippingList/* default */.Z; },
  "YE": function() { return /* reexport */ Sidebar/* default */.Z; }
});

// UNUSED EXPORTS: ActionCard, ActionDetail, BestInstallment, CardanFormFull, CardanFormLicensePlate, DeliveryGuarantee, FastFilter, FilterDelivery, ImportTaxes, InlineFilter, LetMeKnow, LoyaltyCommission, MediaGallery, OpinionSnippetBlock, ProductCardHorizontal, ProductCarousel, ProductList, ReviewStats, Showcase, TagInternational, TextList, ZipcodeBar

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionCard/index.js + 2 modules
var ActionCard = __webpack_require__(5530);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/index.js + 2 modules
var ActionDetail = __webpack_require__(92877);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/AttributeList/index.js + 1 modules
var AttributeList = __webpack_require__(36103);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/BestInstallment/index.js + 3 modules
var BestInstallment = __webpack_require__(88586);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormFull/index.js + 2 modules
var CardanFormFull = __webpack_require__(18559);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormLicensePlate/index.js + 2 modules
var CardanFormLicensePlate = __webpack_require__(37331);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/index.js + 4 modules
var DeliveryGuarantee = __webpack_require__(28426);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/index.js + 2 modules
var FilterDelivery = __webpack_require__(63486);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemAttribute/index.js + 1 modules
var FilterItemAttribute = __webpack_require__(46212);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/index.js + 2 modules
var FilterItemContainer = __webpack_require__(25115);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemReview/index.js + 1 modules
var FilterItemReview = __webpack_require__(18136);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemPrice/index.js + 1 modules
var FilterItemPrice = __webpack_require__(33723);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/index.js + 4 modules
var ImportTaxes = __webpack_require__(66608);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/index.js + 2 modules
var LetMeKnow = __webpack_require__(75057);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LinksMenu/index.js + 2 modules
var LinksMenu = __webpack_require__(57669);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/index.js + 2 modules
var LoyaltyCommission = __webpack_require__(99075);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/index.js + 4 modules
var MediaGallery = __webpack_require__(60857);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/index.js + 3 modules
var OpinionSnippetBlock = __webpack_require__(56337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 18 modules
var ProductCard = __webpack_require__(47719);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js + 3 modules
var ProductList = __webpack_require__(98284);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/HeaderLinks/index.js + 2 modules
var HeaderLinks = __webpack_require__(18367);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/formatDateDistance/index.js + 1 modules
var formatDateDistance = __webpack_require__(41544);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 36 modules
var molecules = __webpack_require__(26865);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCharacteristics/review-characteristics.styles.js



const Container = styled_components_browser_esm["default"].div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > ul {
    width: 100%;
    margin-top: 20px;
  }

  ${(0,esm.getMediaQuery)('large')} {
    flex-direction: row;
    width: 100%;

    > ul {
      width: ${({
  showScoreDesc
}) => !showScoreDesc ? '100%' : '50%'};
    }
  }
`;
const Main = styled_components_browser_esm["default"].div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(0,esm.getMediaQuery)('large')} {
    flex-direction: column-reverse;
    flex: 1;
  }
`;
const Content = styled_components_browser_esm["default"].div`
  margin-left: 8px;

  > div {
    margin-left: -4px;
  }
`;
const Line = styled_components_browser_esm["default"].li`
  display: grid;
  grid-template-columns: 2fr 2fr auto;
  align-items: center;
  grid-gap: 8px;

  & > p:first-child {
    font-size: ${(0,esm.themeGet)('fontSizes.1')}px;
    line-height: ${(0,esm.themeGet)('lineHeights.display')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > p:last-child {
    font-weight: ${props => (0,esm.themeGet)('fontWeights.bold')(props)};
  }

  ${(0,esm.getMediaQuery)('large')} {
    grid-template-columns: 1fr 2fr auto;
  }
`;
const Score = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-weight: ${props => (0,esm.themeGet)('fontWeights.medium')(props)};
  font-size: ${props => (0,esm.themeGet)('fontSizes.7')(props)}px;

  & > span {
    display: none;
  }

  ${(0,esm.getMediaQuery)('large')} {
    line-height: ${props => (0,esm.themeGet)('lineHeights.fontSize')(props)};

    & > span {
      display: inline-block;
    }
  }
`;
const Description = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-size: ${props => (0,esm.themeGet)('fontSizes.1')(props)}px;
  color: ${props => (0,esm.getTextColor)('light')(props)};

  ${(0,esm.getMediaQuery)('large')} {
    margin-top: ${props => (0,esm.themeGet)('space.3')(props)}px;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCharacteristics/review-characteristics.js







function ReviewCharacteristics({
  average,
  count: total,
  characteristics,
  showScoreDesc
}) {
  const desc = total > 1 ? `${total} avaliações` : `${total} avaliação`;
  return /*#__PURE__*/react.createElement(Container, {
    showScoreDesc: showScoreDesc
  }, showScoreDesc && /*#__PURE__*/react.createElement(Main, null, /*#__PURE__*/react.createElement(Score, {
    "data-testid": "stat-score"
  }, /*#__PURE__*/react.createElement("span", null, "Nota:"), ` ${average.toFixed(1)}`), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    score: average,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "stat-desc"
  }, desc))), /*#__PURE__*/react.createElement("ul", null, characteristics == null ? void 0 : characteristics.map(item => /*#__PURE__*/react.createElement(Line, {
    key: item.label
  }, /*#__PURE__*/react.createElement(Text/* default */.Z, null, item.label), /*#__PURE__*/react.createElement(atoms/* LinearProgress */.uk, {
    height: "8px",
    color: "#0086ff",
    value: item.value,
    max: 5
  }), /*#__PURE__*/react.createElement(Text/* default */.Z, null, item.value.toFixed(1))))));
}

ReviewCharacteristics.defaultProps = {
  average: 0,
  count: 0,
  characteristics: [],
  showScoreDesc: true
};
 false ? 0 : void 0;
/* harmony default export */ var review_characteristics = (ReviewCharacteristics);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCharacteristics/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCard/review-card.styles.js




const review_card_styles_Container = styled_components_browser_esm["default"].div`
  ${(0,esm.getMediaQuery)('large')} {
    display: flex;
  }
`;
const TitleName = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  margin-top: 4px;
  font-size: ${props => (0,esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,esm.themeGet)(props.bold ? 'fontWeights.medium' : 'fontWeights.regular')(props)};
  color: ${props => (0,esm.getTextColor)('base')(props)};

  > span {
    color: ${props => (0,esm.getTextColor)('lighter')(props)};
  }
`;
const TitleReview = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  margin-top: 12px;
  font-size: ${props => (0,esm.themeGet)('fontSizes.5')(props)}px;
  font-weight: ${props => (0,esm.themeGet)('fontWeights.medium')(props)};
  color: ${props => (0,esm.getTextColor)('base')(props)};
  line-height: ${props => (0,esm.themeGet)('lineHeights.display')(props)};
`;
const review_card_styles_Description = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  margin: 12px 0;
  font-size: ${props => (0,esm.themeGet)('fontSizes.1')(props)}px;
  color: ${props => (0,esm.getTextColor)('scratched')(props)};
  line-height: ${props => (0,esm.themeGet)('lineHeights.plus')(props)}px;
  text-align: justify;
`;
const Divider = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  border-bottom: 3px solid ${props => (0,esm.getBorderColor)('light')(props)};
  margin: 16px 0px;
  width: 100%;
`;
const Recommended = (0,styled_components_browser_esm["default"])(Text/* default */.Z)`
  font-size: ${props => (0,esm.themeGet)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,esm.themeGet)('fontWeights.medium')(props)};

  color: ${props => props.reviewOK ? (0,esm.themeGet)('baseColors.lima.base')(props) : (0,esm.themeGet)('baseColors.vermillion.base')(props)};
`;
const ContainerReview = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  ${(0,esm.getMediaQuery)('large')} {
    width: 50%;
    flex: 1;
    margin-right: 32px;
  }
`;
const ContainerReviewCharacteristics = (0,styled_components_browser_esm["default"])(Box/* default */.Z)`
  ${(0,esm.getMediaQuery)('large')} {
    align-self: center;
    width: 50%;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCard/review-card.js







function ReviewCard({
  title,
  text,
  rating,
  recommended,
  user,
  date,
  characteristics,
  showScoreDesc
}) {
  const recoText = recommended ? 'Sim, eu recomendo esse produto' : 'Não, eu não recomendo esse produto';
  const days = date && (0,formatDateDistance/* default */.Z)(new Date(date), new Date());
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(review_card_styles_Container, {
    "data-testid": "review-card"
  }, /*#__PURE__*/react.createElement(ContainerReview, null, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    score: rating,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/react.createElement(TitleName, null, (user == null ? void 0 : user.name) || 'Anônimo', " - ", /*#__PURE__*/react.createElement("span", null, "H\xE1 ", days)), /*#__PURE__*/react.createElement(TitleReview, {
    bold: true
  }, title), /*#__PURE__*/react.createElement(review_card_styles_Description, null, text), /*#__PURE__*/react.createElement(Recommended, {
    reviewOK: recommended
  }, recoText)), /*#__PURE__*/react.createElement(ContainerReviewCharacteristics, null, /*#__PURE__*/react.createElement(review_characteristics, {
    characteristics: characteristics,
    showScoreDesc: showScoreDesc
  }))), /*#__PURE__*/react.createElement(Divider, null));
}

ReviewCard.defaultProps = {
  user: {
    name: 'Anônimo'
  },
  showScoreDesc: false
};
 false ? 0 : void 0;
/* harmony default export */ var review_card = (ReviewCard);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCard/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/index.js + 2 modules
var ReviewStats = __webpack_require__(4506);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/index.js + 11 modules
var ProductReviewPopup = __webpack_require__(77576);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js + 5 modules
var SellerDelivery = __webpack_require__(30143);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ShippingList/index.js + 1 modules
var ShippingList = __webpack_require__(2334);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/index.js + 10 modules
var Showcase = __webpack_require__(75335);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/index.js + 2 modules
var TextList = __webpack_require__(35306);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/index.js + 2 modules
var ZipcodeBar = __webpack_require__(41323);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/index.js + 2 modules
var FastFilter = __webpack_require__(90713);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/InlineFilter/index.js + 2 modules
var InlineFilter = __webpack_require__(76228);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js + 2 modules
var TagInternational = __webpack_require__(37215);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/index.js + 3 modules
var ProductReviewGallery = __webpack_require__(99970);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/index.js + 2 modules
var ProductCardHorizontal = __webpack_require__(3018);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js






































/***/ })

}]);